module.exports = __webpack_public_path__ + "static/map-shape1-4b98bca3bcf9f47dc8907ab2fffd3922.png";